/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMapIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-map"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M14.2 21.5L8.93 19.65L4.03 21.55Q3.7 21.68 3.39 21.63Q3.08 21.57 2.8 21.4Q2.52 21.23 2.38 20.95Q2.23 20.68 2.23 20.32L2.23 5.2Q2.23 4.85 2.45 4.56Q2.67 4.28 3.02 4.15L8.05 2.45Q8.25 2.38 8.47 2.34Q8.7 2.3 8.93 2.3Q9.15 2.3 9.36 2.34Q9.57 2.38 9.78 2.45L15.07 4.3L19.98 2.4Q20.3 2.27 20.61 2.33Q20.93 2.38 21.2 2.55Q21.48 2.73 21.63 3Q21.77 3.27 21.77 3.63L21.77 18.7Q21.77 19.05 21.57 19.34Q21.38 19.63 21.02 19.75L15.95 21.5Q15.75 21.57 15.53 21.61Q15.3 21.65 15.07 21.65Q14.85 21.65 14.63 21.61Q14.4 21.57 14.2 21.5ZM13.72 18.55L13.72 6.65L10.28 5.4L10.28 17.35Z" fill={color} />
    </svg>
  );
}
